import { Component, Input, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-kindsmodal',
  templateUrl: './kindsmodal.component.html',
  styleUrls: ['./kindsmodal.component.css']
})
export class KindsModalComponent {
  @Input() id: string = 'atypesModal';

  private destroy$ = new Subject();

  constructor(public _data: DataService,
    public _blogic: BusinesLogicService,
    public _modal: ModalHelper) { }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Change the pre evaluation kind */
  public changeKind(id: number, name: string): void {
    let params = {
      desk_id: this._data.session["desk"],
      turn_id: (this._data.turn != null) ? this._data.turn["id"] : this._data.selectedTurn["id"],
      prekind_id: id,
      deskuser: this._data.session["username"]
    };

    this._blogic.changeTurnKind(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._modal.hide(this.id);
          if (this._data.turn != null) {
            this._data.turn["prekind_id"] = id;
            this._data.turn["prekindname"] = name;
            this._data.turnChanged();
          }
        }
      );
  }

  public openKindModal(id: string) {
    this._modal.show(id);
  }
}
